import Vue from 'vue'
import Vuex from 'vuex'
import UserProfile from '@/store/modules/UserProfile'
import IdeaCategories from '@/store/modules/IdeaCategories'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    UserProfile,
    IdeaCategories
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js